import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import type { MergedState } from 'src/app/shared/hooks/state';
import { useMergedStates } from 'src/app/shared/hooks/state';
import { getQueryStringSingleValue } from 'src/app/shared/utils/query';

import { prefetchTopicSitemapPageDataFromApi, useTopicSitemapPageDataFromApi } from './pageData';

export type TopicSitemapPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useTopicSitemapPageDataFromApi>[0]>;
}>;

export type TopicSitemapPageCombinedState = MergedState<ReturnType<typeof useTopicSitemapPageDataFromApi>>;

export function usePageContext(prefetchedData?: TopicSitemapPagePrefetchedContext): TopicSitemapPageCombinedState {
	const startsWith = useQueryParamValue('starts_with');
	return useMergedStates(useTopicSitemapPageDataFromApi(prefetchedData?.pageData, { startsWith }));
}

export async function prefetchPageContext(context: PrefetchContext): Promise<TopicSitemapPagePrefetchedContext> {
	const startsWith = getQueryStringSingleValue(context.query, 'starts_with');
	const [pageData] = await Promise.all([prefetchTopicSitemapPageDataFromApi(context, { startsWith })]);

	return { pageData };
}

export type TopicSitemapPagePrefetchedDataProps = PrefetchedDataProps<TopicSitemapPagePrefetchedContext>;
